// ConsoleV2.jsx — the updated admin dashboard: real metrics (Overview) and
// the plantsona review grid (Plantsonas). Mounted at /console/v2.

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import OverviewTab from "./OverviewTab";
import PlantsonasTab from "./PlantsonasTab";
import "./ConsoleV2.css";

const TABS = [
  { key: "overview", label: "Overview" },
  { key: "plantsonas", label: "Plantsonas" },
];

const ConsoleV2 = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState("overview");

  return (
    <div className="cv2Root">
      <header className="cv2Header">
        <div className="cv2HeaderLeft">
          <button className="cv2Back" onClick={() => navigate("/console")}>
            ← Console
          </button>
          <h1>
            Leaflings <span>Console V2</span>
          </h1>
        </div>
        <nav className="cv2Tabs">
          {TABS.map((t) => (
            <button
              key={t.key}
              className={`cv2Tab${tab === t.key ? " active" : ""}`}
              onClick={() => setTab(t.key)}
            >
              {t.label}
            </button>
          ))}
        </nav>
      </header>
      <main className="cv2Main">
        {tab === "overview" ? <OverviewTab /> : <PlantsonasTab />}
      </main>
    </div>
  );
};

export default ConsoleV2;
